import { Controller } from "@hotwired/stimulus";

type ClipboardWriter = {
    writeText(value: string): Promise<void>;
};

type TimeoutScheduler = (callback: () => void, timeoutInMilliseconds: number) => void;

const visibleIconDisplay = "inline-block";
const copiedTooltipTitle = "Unique Id copied to Clipboard";

export async function copyValueAndToggleIcons(
    value: string,
    copyIcon: HTMLElement,
    checkIcon: HTMLElement,
    tooltipElement?: HTMLElement,
    clipboard: ClipboardWriter = navigator.clipboard,
    schedule: TimeoutScheduler = (callback, timeoutInMilliseconds) => {
        setTimeout(callback, timeoutInMilliseconds);
    }
): Promise<void> {
    await clipboard.writeText(value);

    copyIcon.style.display = "none";
    checkIcon.style.display = visibleIconDisplay;
    showCopiedTooltip(tooltipElement);

    schedule(() => {
        copyIcon.style.display = visibleIconDisplay;
        checkIcon.style.display = "none";
        hideCopiedTooltip(tooltipElement);
    }, 1000);
}

function showCopiedTooltip(tooltipElement?: HTMLElement) {
    if (!tooltipElement) return;

    const tooltip = $(tooltipElement) as any;
    tooltip.tooltip("dispose");
    tooltip.tooltip({
        title: copiedTooltipTitle,
        trigger: "manual"
    });
    tooltip.tooltip("show");
}

function hideCopiedTooltip(tooltipElement?: HTMLElement) {
    if (!tooltipElement) return;

    const tooltip = $(tooltipElement) as any;
    tooltip.tooltip("hide");
    tooltip.tooltip("dispose");
}

export default class CopyAndPasteButtonController extends Controller {
    static targets = ["copyIcon", "checkIcon"];
    static values = {
        value: String
    };

    readonly copyIconTarget!: HTMLElement;
    readonly checkIconTarget!: HTMLElement;
    readonly valueValue!: string;

    async copy() {
        await copyValueAndToggleIcons(
            this.valueValue,
            this.copyIconTarget,
            this.checkIconTarget,
            this.element as HTMLElement
        );
    }
}
